<template>
  <div v-if="element" class="array-container">
    <div class="array-label">
      <button v-if="container.CanAddElement != false" class="add-sub-element-button" @click="showAddSubElementPopup = true">
        <addIcon/>
      </button>
      <span>{{ property.label ? property.label : "Element dans" }} {{ container.Name }}</span>
    </div>
    <div class="array-content" v-show="element.length > 0">
      <transition-group 
        name="array-item" 
        tag="div" 
        class="array-items-container"
        appear
      >
        <div v-for="(e, index) in element" :key="e.id || `${e.name}-${index}`" :style="{ '--i': index }" class="array-item">
          <component :isComposition="isComposition" :is="property.elements.type" :property="property.elements" :element="e" :container="container" :position="index" :lengthIsIn="element.length" />
        </div>
      </transition-group>
    </div>

    <AddSubElementPopup
      :show="showAddSubElementPopup"
      :containerName="container.Name"
      :subElements="getSubElement()"
      :label="property.label ? property.label : null"
      @close="showAddSubElementPopup = false"
      @select="addSubElement"
    />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapActions } from 'vuex';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import AddSubElementPopup from "../PopupComponents/AddSubElementPopup.vue"
import addIcon from "../IconComponents/addIcon.vue"
import listElement from "../../vuexStore/type/definition/listElement.js"

export default {
  name: 'ArrayInput',
  components: {
    'colorInput': defineAsyncComponent(() => import('@/components/PropertyComponents/color.vue')),
    'numberInput': defineAsyncComponent(() => import('@/components/PropertyComponents/number.vue')),
    'booleanInput': defineAsyncComponent(() => import('@/components/PropertyComponents/boolean.vue')),
    'selectInput': defineAsyncComponent(() => import('@/components/PropertyComponents/select.vue')),
    'textInput': defineAsyncComponent(() => import('@/components/PropertyComponents/text.vue')),
    'pathInput': defineAsyncComponent(() => import('@/components/PropertyComponents/path.vue')),
    'objectInput': defineAsyncComponent(() => import('@/components/PropertyComponents/object.vue')),
    'rangeInput': defineAsyncComponent(() => import('@/components/PropertyComponents/range.vue')),
    AddSubElementPopup,
    addIcon
  },
  props: {
    isComposition: {
      type: Boolean,
      required: false,
      default: false
    },
    property: {
      type: Object,
      required: true
    },
    element: {
      type: Array,
      required: true
    },
    container: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showAddSubElementPopup: false
    }
  },
  computed: {
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      'addElement': actions.ADD_ELEMENT
    }),
    addSubElement(element) {
      this.addElement({
        target: element.property,
        toAdd: element.toAdd.constructor.fromObject({parent: this.container}),
        element: this.container
      });
      this.showAddSubElementPopup = false;
    },
    getSubElement() {
      let elementsToadd = [];
      if (!this.container) return elementsToadd;
      const elementOption = listElement.find(el => el.name === this.property.elementOption).value;
      for (const el of elementOption) {
        if (el.type === this.container.objectType) {
          elementOption.forEach(element => {
            const find = el.subType.find(subType => {
              if (element.type.match(subType.type) && element.ignoreOnStandardElement !== true) {
                if (subType.is == "array")
                  return true;
                else if (this.container[subType.property] == null)
                  return true;
              }
              return false;
            })
            if (find) {
              elementsToadd.push({toAdd: element, property: find.property});
            }
          });
          return elementsToadd;
        }
      }
      return elementsToadd;
    }
  }
}
</script>

<style scoped>
.array-container {
  margin-top: 1rem;
}

.array-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 1rem;
  color: #bfbfbf;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  text-shadow: 0px 0px 10px black;
}

.array-content {
  background: radial-gradient(circle,rgb(30, 57, 135) 0%, rgba(29, 29, 29, 0.46) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  padding: 0.4rem;
  /* border: 1px solid black; */
}

/* Les marges sont maintenant gérées par le conteneur flex avec gap */

.add-sub-element-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  background-color: rgb(50, 111, 210);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: white;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-sub-element-button > div {
  font-size: 14px;
  flex: 1;
}

.add-sub-element-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.add-sub-element-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

/* Animations pour les éléments du tableau */
.array-items-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
}

.array-item-enter-active {
  transition: all 0.4s ease-out;
  transition-delay: calc(var(--i) * 0.1s);
}

.array-item-leave-active {
  transition: all 0.3s ease-in;
}

.array-item-enter-from {
  opacity: 0;
  transform: translateX(50px);
}

.array-item-leave-to {
  opacity: 0;
  transform: translateX(50px);
}

.array-item-move {
  transition: transform 0.3s ease;
}

/* S'assurer que les éléments ont une position relative pour l'animation de sortie */
.array-item {
  position: relative;
}
</style>
